module.exports = __webpack_public_path__ + "src/assets/img/start/1c4d5abeca1b3b50cac014c3dd2f65bb.png";